// i18n area 'networks' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.da-DK.meta.json.
import type { enUS } from './networks'

export const daDK: typeof enUS = {
  networks: {
    common: {
      name: 'Navn',
      scope: 'Scope',
      operState: 'Status',
      actions: 'Handlinger',
      create: 'Opret',
      close: 'Luk',
      cancel: 'Annuller',
      delete: 'Slet',
      edit: 'Rediger',
      save: 'Gem',
      editError: 'Redigeringen mislykkedes',
      search: 'Søg efter navn',
      empty: 'Endnu intet her',
      saveError: 'Kunne ikke gemme',
      loadError: 'Kunne ikke indlæse — kan TVirt-backenden nås?',
      createError: 'Oprettelsen mislykkedes',
      deleteError: 'Sletningen mislykkedes',
      deleteConfirmTitle: 'Slette {name}?',
      deleteConfirmBody: 'Operationen kan ikke fortrydes.',
      nameHint: 'Små bogstaver, cifre og bindestreger (DNS-1123)',
      up: 'Aktiv',
      down: 'Ikke aktiv',
      unknown: 'Ukendt',
      usedByVMs: 'VM',
      emptyTable: 'Ingen poster — tilføj en med +-knappen'
    },
    dialogTabs: {
      general: 'Generelt',
      base: 'Basisdefinition',
      advanced: 'Avanceret konfiguration',
      reserved: 'Ranges reserveret til TVirt',
      position: 'Position',
      network: 'Netværkskonfiguration',
      hosts: 'Deltagende noder'
    },
    reservedRanges: {
      note: 'Dette er de IP-ranges, der er reserveret til TVirt, og som platformen kan bruge til automatisk at tildele en adresse til VM, containere osv. BEMÆRK: IP-adresser i disse ranges må ikke bruges uden for TVirt af eksterne tjenester/apparater.',
      from: 'Fra',
      to: 'Til'
    },
    overlay: {
      title: 'Overlay-netværk',
      createTitle: 'Opret overlay-netværk',
      editTitle: 'Rediger overlay-netværk',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — tildeles automatisk hvis tomt',
      subnet: 'Subnet',
      subnetHint: 'Overlayets CIDR — IPAM afleder automatisk dets registerpost',
      mtu: 'MTU',
      weight: 'Vægt',
      ceilMbps: 'Loft (Mbps)',
      fairnessHint: 'Vægten gælder kun under belastning: på et ledigt link kan hvert netværk bruge hele båndbredden. Loftet gælder derimod altid.',
      contention: 'Kappestrid',
      contentionTip: 'Mindst én node observerer tab eller overlimits MED kø på dette netværks klasse: uplinkets båndbredde er omstridt, og vægtene virker. Hvor meget og siden hvornår står i nodens net.shaping.*-serier.',
      firewallPolicy: 'Firewall-politik',
      hosts: 'Hosts',
      hostsTitle: 'Deltagende noder',
      hostsHint: 'Hver node erklærer sit underlay-endpoint — en select over nodens VIRKELIGE adresser, læst fra dens netværkskonfiguration; den valgfri overlay-adresse skal ligge i subnettet. Deltagelsen er placement-bindingen.',
      hostNode: 'Node',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Vælg noden først',
      hostAddress: 'Adresse på overlayet (valgfri)',
      hostAddressOutside: 'Uden for overlay-subnettet ({cidr})',
      addHost: 'Tilføj node',
      observedAt: 'Observeret',
      attachedNics: 'Tilsluttede NIC'
    },
    services: {
      title: 'Netværkstjenester',
      createTitle: 'Opret netværkstjeneste',
      editTitle: 'Rediger netværkstjeneste',
      kind: 'Type',
      kindCategory: 'Tjenester',
      selectKindHint: 'Vælg tjenestetypen — den underliggende daemon er en implementeringsdetalje, som TVirt håndterer for dig.',
      kindLabel: {
        dhcp: 'DHCP-server',
        ntp: 'NTP-server',
        vpn: 'VPN-server',
        dns: 'DNS-server',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer og reverse proxy',
        floatip: 'Flydende IP'
      },
      kindDesc: {
        dhcp: 'Tildeler adresser på de betjente subnets — pools afledes af netværkets subnet, gateway og TVirt-reserverede ranges.',
        dns: 'Autoritativ DNS for de erklærede zoner — records afledes af IPAM plus dine manuelle.',
        gateway: 'Noden fungerer som gateway for et netværk — NAT (DNAT, 1:1, SNAT/masquerade) plus statisk routing mellem de tilsluttede netværk, selvhelbredende by design.',
        'lb-rp': 'Load balancer / reverse proxy foran dine tjenester — L4- eller L7-listeners over pools af medlemmer eller over en Pods klare instanser, omkonfigureret under drift.',
        ntp: 'Netværkenes tidstjeneste — relay af eksterne upstream-servere, eller nodens ur serveret til klienterne.',
        vpn: 'En VPN-koncentrator på noden — WireGuard eller OpenVPN, du vælger: fjernadgang for klienter på farten, eller en site to site-tunnel mellem to netværk.',
        floatip: 'Én adresse, der sidder på én sund App-instans eller Pod ad gangen og flytter til det næste sunde mål, når den falder — failover uden dæmoner; balanceringen bliver hos load balanceren.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Den flydende IP lever på det valgte netværk som en EKSTRA adresse inde i holderinstansens eget navnerum: ingen porte, ingen balancering, ingen NAT — klientens IP forbliver ægte.',
        address: 'Flydende IP',
        targets: 'Mål',
        targetsHint: 'I PRÆFERENCE-rækkefølge: det første sunde mål holder adressen. En Pod står for alle dens instanser, efter replika; hvert mål har sit eget sundhedskriterium. Hvert mål skal være tilsluttet samme netværk.',
        targetKind: 'Mål',
        targetApp: 'App-instans',
        targetPod: 'Pod (alle instanser)',
        targetRef: 'Hvilken',
        health: 'Sundhed',
        healthRunning: 'Kører (alle containere klar)',
        healthTcp: 'TCP-forbindelse',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Sti',
        addTarget: 'Tilføj mål',
        moveUp: 'Flyt op',
        moveDown: 'Flyt ned',
        preempt: 'Preempt',
        preemptHint: 'Fra (standard): en sund holder beholder adressen, selv når et højere mål kommer tilbage — ingen flapping. Til: det første sunde mål holder den altid.',
        holder: 'Holder',
        noHolder: 'intet sundt mål',
        since: 'siden',
        verdicts: 'Observerede mål',
        healthy: 'sund',
        unhealthy: 'usund',
        noVerdict: 'Ikke afgjort endnu — autoritetsnoden skriver den første dom ved sin næste gennemgang.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Denne instans holder den flydende IP {address} for tjenesten {service}'
      },
      poolSource: 'Endpoints',
      poolSourceMembers: 'Statiske medlemmer',
      poolSourcePod: 'En Pods klare instanser',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Endpoints følger Pod\'en: en instans kommer ind, når den kører med alle containere klar, og forlader straks, når den skaleres ned eller dør. Den aktive kontrol er slået til som standard.',
      poolBackendCount: 'de klare instanser af Pod {pod} på port {port}',
      node: 'Node',
      enabled: 'Aktiveret',
      parked: 'Parkeret',
      subnets: 'Subnets',
      subnetsHint: 'De IPAM-subnets, denne instans betjener — pools afledes af CIDR, gateway og TVirt-reserverede ranges',
      noSubnets: 'Ingen IPAM-subnet — erklær først et logisk fabric-netværk (eller et overlay-subnet): IPAM afledes af dem',
      iface: 'Lytteinterface',
      ifaceHint: 'Værtsinterfacet som tjenesten åbner sin socket på (f.eks. en bridge) — påkrævet: en netværkstjeneste er selvstændig, "alle interfaces" findes ikke længere',
      dns: 'DNS-servere',
      domain: 'Domæne',
      detail: 'Betjener',
      subnetCount: '{n} subnets',
      zones: 'Zoner',
      zonesHint: 'Kun autoritativ — daemonen laver aldrig rekursion. A-records afledes af nodernes erklærede adresser i de refererede IPAM-subnets; reverse-switchen betjener også de tilsvarende in-addr.arpa-zoner (PTR). En zone betjenes af højst én DNS-instans i flåden. Den valgfri nameserver er den FQDN, der skrives i NS-/SOA-records i stedet for defaulten ns.<zone>; falder den inden for zonen, afledes dens A-record alligevel af den betjenende node.',
      zoneName: 'Zonenavn',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM-subnets',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Manuelle records',
      zoneRecordsHint: 'Én pr. linje: navn TYPE værdi — typerne A, CNAME, MX, TXT. Ved navnekollision vinder den manuelle record over den afledte.',
      addZone: 'Tilføj zone',
      lbListeningHint: 'Instansen erklærer ÉT lyttenetværk og ÉN adresse — hver listener binder den på sin egen port; en anden adresse er en anden tjeneste.',
      listeners: 'Listeners',
      listenersHint: 'Hver listener binder instansens adresse på sin egen port i L4-tilstand (TCP-passthrough — bytes åbnes aldrig) eller L7 (HTTP) og videresender til en af puljerne nedenfor. Et adresse/port-par betjenes af højst én instans pr. node. Ændringer træder i kraft i farten — ingen genstart, ingen tabte forbindelser.',
      listenerName: 'Navn',
      listenerMode: 'Tilstand',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP-passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Tilføj listener',
      pools: 'Pools',
      poolsHint: 'De backends, trafikken lander på: statiske medlemmer balanceret round-robin eller efter mindst optaget, med et valgfrit aktivt health check, der tager de syge medlemmer ud af rotationen.',
      poolName: 'Navn',
      poolAlgorithm: 'Algoritme',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Mindst optaget',
      poolCheck: 'Health check',
      checkNone: 'Intet',
      checkTcp: 'TCP-forbindelse',
      checkHttp: 'HTTP',
      poolCheckPath: 'Sondens sti',
      poolInterval: 'Interval (s)',
      poolMembers: 'Medlemmer',
      poolMembersHint: 'Ét pr. linje: adresse:port, valgfrit efterfulgt af en vægt (1-128) — fx 10.0.0.21:8080 2',
      addPool: 'Tilføj pool',
      memberCount: '{n} medlemmer',
      listen: {
        assignment: 'Tildeling',
        assignmentStatic: 'Statisk adresse',
        assignmentAuto: 'Automatisk (TVirt-reserverede områder)',
        autoHint: 'TVirt trækker adressen fra det logiske netværks reserverede områder og holder den sticky — aldrig trukket igen ved en redigering eller failover.',
        title: 'Listeners',
        hint: 'En netværkstjeneste er selvstændig: hver listener erklærer sit netværk (overlay, logisk fabric-netværk eller råt interface) og en adresse i dets subnet — én listener pr. adresse, wildcard findes ikke længere. DNS og NTP kan lytte på flere netværk og flere adresser i de netværk.',
        address: 'Lytteadresse',
        add: 'Tilføj listener'
      },
      ntp: {
        mode: 'Synkroniseringstilstand',
        modeRelay: 'Relay af eksterne servere',
        modeNodeClock: 'Nodens ur',
        modeHint: 'Relayet serverer tiden hentet fra de erklærede upstream-servere; nodens ur serverer den betjenende nodes tid — som clusteret alligevel holder synkroniseret',
        servers: 'Upstream-servere',
        serversHint: 'Kommaseparerede — hostname eller IP-adresse; tjenesten henter tiden herfra og serverer den til netværket',
        port: 'Lytteport',
        listening: 'Lytter på'
      },
      vpn: {
        engine: 'Motor',
        engineHint: 'Du vælger den, og den ændres aldrig igen: WireGuard er moderne, hurtig og in-kernel; OpenVPN er kompatibilitetens veteran (TCP, fjendtlige netværk)',
        engineLocked: 'Motoren er uforanderlig — en anden motor er en ny tjeneste, nøgler og certifikater er ikke portable',
        mode: 'Tilstand',
        modeRemote: 'Fjernadgang',
        modeSite: 'Site to site',
        modeHint: 'Fjernadgang giver klienter på farten en adresse i tunnelen; site to site forener to netværk',
        port: 'Lytteport',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard taler kun UDP',
        tunnelSubnet: 'Tunnelens subnet',
        tunnelSubnetHint: 'Netværket, klienterne bor i — registreret i IPAM-registret, det fødes og dør med denne tjeneste',
        dnsServers: 'DNS pushet til klienterne',
        routes: 'Ruter pushet til klienterne',
        routesHint: 'Kommaseparerede netværk, der kan nås i tunnelen; tunnelens subnet er altid inkluderet',
        peers: 'Peers',
        peersHint: 'Lad den offentlige nøgle stå tom, så genererer TVirt nøgleparret — og leverer det med profilen. Indsæt en nøgle, og peeren beholder sin egen.',
        clients: 'Klienter',
        clientsHint: 'Hver klient får et certifikat udstedt af denne tjenestes CA. At fjerne en klient TILBAGEKALDER den: CRL genereres straks igen.',
        peerName: 'Navn',
        publicKey: 'Offentlig nøgle',
        publicKeyMinted: 'TVirt genererer den',
        peerAddress: 'Adresse i tunnelen',
        peerAddressHint: 'Tom = tildeles',
        allowedIps: 'Fjern-subnets',
        allowedIpsHint: 'Kommaseparerede, routet gennem denne peer',
        endpoint: 'Endpoint',
        presharedKey: 'Pre-shared nøgle',
        keepalive: 'Keepalive (s)',
        addPeer: 'Tilføj peer',
        addClient: 'Tilføj klient',
        auth: 'Autentificering',
        authTls: 'Certifikater (TLS)',
        remote: 'Fjern-endpoint',
        remoteHint: 'host:port for den fjerne ende — tomt betyder, at denne side venter',
        peerRoutes: 'Fjern-subnets',
        serverPublicKey: 'Denne servers offentlige nøgle',
        ca: 'Certificeringsmyndighed',
        listening: 'Lytter på',
        tunnel: 'Tunnel',
        peerCount: '{n} peers',
        download: 'Download profil',
        downloadError: 'Profilen kunne ikke eksporteres',
        lastHandshake: 'Seneste handshake',
        never: 'aldrig',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Forbundet',
        idle: 'Inaktiv'
      },
      gateway: {
        attach: 'Type af lyttenetværk',
        attachOverlay: 'Overlay-netværk',
        attachNetwork: 'Logisk fabric-netværk',
        attachInterface: 'Råt interface',
        overlay: 'Overlay-netværk',
        network: 'Logisk netværk',
        interface: 'Interfacenavn',
        interfaceHint: 'Et host-interface, som TVirt ikke håndterer — adressen tages for gode varer',
        address: 'Lytteadresse (gateway)',
        addressHint: 'Gateway-adressen, klienterne peger på — inden for lyttenetværkets subnet',
        dnatTitle: 'DNAT-regler',
        dnatHint: 'Destinations-NAT: trafik i matchet redirigeres til en ny adresse (og valgfrit en ny port). Enhver protokol fra listen — porte dér, hvor protokollen bærer dem.',
        snatTitle: 'SNAT-regler',
        snatHint: 'Kilde-NAT: trafik i matchet forlader med omskrevet kilde — en ny eksplicit adresse (og valgfrit en ny port), eller masquerade på udgangsadressen, hvis feltet står tomt.',
        oneToOneTitle: '1:1 NAT-regler',
        oneToOneHint: 'Hver pakke til den eksterne adresse mapper til den interne, og den interne host går ud som den eksterne — alle protokoller, begge retninger.',
        external: 'Ekstern adresse',
        internal: 'Intern adresse',
        addOneToOne: 'Tilføj 1:1-regel',
        family: 'Familie',
        protocol: 'Protokol',
        source: 'Kilde (adresse/subnet)',
        destination: 'Destination (adresse/subnet)',
        invert: 'NOT',
        srcPorts: 'Kildeporte',
        dstPorts: 'Dest.-porte',
        dstPortsHint: 'Port eller range (80, 8000-8099)',
        toAddress: 'Ny adresse',
        toPort: 'Ny port',
        snatTo: 'Ny kilde (tom = masquerade)',
        snatToHint: 'Eksplicit kildeadresse; tom = masquerade på udgangsadressen',
        addDnat: 'Tilføj DNAT-regel',
        addSnat: 'Tilføj SNAT-regel',
        routesTitle: 'Statiske ruter',
        routesHint: 'Noden router mellem de netværk, den er tilsluttet (IP forwarding er aktiv); disse ruter tilføjer rækkevidde ud over dem — ren kernel, dynamisk routing kommer med et senere round.',
        routeDestination: 'Destinations-subnet',
        routeGateway: 'Next hop',
        routeMetric: 'Metrik',
        addRoute: 'Tilføj rute',
        listening: 'Lytter på',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} ruter'
      },
      unknownSince: 'Ukendt — seneste rapport for {m} min. siden',
      lastWord: 'Sidste ord',
      reportObservedAt: 'Seneste rapport',
      lastErrorRow: 'Seneste fejl',
      recordsCount: '{n} manuelle records',
      phase: {
        configured: 'Konfigureret',
        running: 'Kører',
        error: 'Fejl'
      },
      authorityNode: 'Authority (tildeling)',
      preferredNode: 'Foretrukken node',
      preferredNodeHint: 'En blød præference, aldrig en begrænsning: ved den næste placement-beslutning lander instansen her, hvis medlemmet er egnet — alene flytter den intet; trækket er "Overfør authority".',
      noPreference: 'Ingen præference (automatisk placement)',
      moving: 'I bevægelse',
      movingTooltip: 'Observeret her, mens authorityen tildeler {node}: trækket er ved at konvergere.',
      placement: {
        title: 'Placement',
        loading: 'Optælling i gang…',
        loadError: 'Placement-optællingen svarede ikke — prøv igen senere.',
        draftHint: 'Optællingen beregnes ud fra den erklærede netværkstilkobling: den dukker op, når tjenesten er oprettet. Oprettelsen afvises, hvis intet medlem kan betjene den, og afvisningen nævner den mekanisme, der tømte mængden.',
        eligibleCount: '{n} af {m} medlemmer kan betjene denne instans',
        recommended: 'Anbefalet',
        eligible: 'Egnet',
        notEligible: 'Ikke egnet',
        blockedReachability: 'netværket når ikke frem til dette medlem',
        blockedRequireTag: 'blokeret af et påkrævet tag (requireNodes)',
        blockedExcluded: 'udelukket af simulationen',
        preferenceUnknown: 'er ikke (længere) medlem af clusteret',
        preferenceIgnored: 'Præferencen "{node}" er ikke egnet i dag: {reason}. Optællingens anbefaling vinder — aldrig en fejl, tjenesten lever et andet sted.',
        emptyReachability: 'Intet medlem kan betjene denne instans: netværket når ingen steder frem — ingen justering af tags vil hjælpe. Træk kabel til noden, eller flyt tjenesten derhen, hvor netværket er.',
        emptyRequireTag: 'Intet medlem kan betjene denne instans: det er de påkrævede tags, der tømte mængden — fjern posten fra requireNodes, eller giv et medlem tagget.',
        spof: 'Single point of failure',
        spofDetail: 'Kun ét medlem kan huse instansen: ved svigt har failoveren ingen steder at gå hen. En multi-listener-tjeneste flytter som en ENHED — kandidaten skal se ALLE dens netværk: det er prisen.',
        whatIf: 'Simuler fraværende medlemmer',
        whatIfHint: 'Drainens what-if: spørg FØR evakueringen, opdag det ikke først ved failover.',
        survives: 'Med {nodes} fraværende har tjenesten stadig et hjem.',
        notSurvives: 'At evakuere {nodes} efterlader denne tjeneste NEDE: den afledte begrænsning vinder over tilgængeligheden (R30) — en daemon i live dér, hvor netværket ikke når frem, betjener ingen og alarmerer ingen.',
        transfer: 'Overfør authority',
        transferError: 'Overførslen mislykkedes',
        transferTarget: 'Målmedlem',
        transferHint: 'Kun egnede medlemmer tilbydes — en præference inden for den gyldige mængde, aldrig et override. Ingen task: workernes næste gennemløb ER trækket (den gamle node høster, den nye rejser).'
      }
    },
    fabric: {
      tabDerivation: 'Derivation',
      importNetwork: 'Importér fra en anden fabric',
      importTitle: 'Importér et logisk netværk',
      importHint: 'Importen er den eksplicitte tilslutning: netværket forbliver ejerens (samme identitet, samme stem, samme bridge tvf-<stem>) og herfra mappes det på denne fabrics porte/LAGG — at mappe ER at hævde, at leveringen ender i samme L2-domæne som ejerens.',
      importPick: 'Ejerens netværk',
      importNone: 'Intet at importere: de andre fabrics har intet eget netværk, som denne fabric ikke allerede kender',
      importedNetworksTitle: 'Importerede netværk',
      noImported: 'Intet importeret netværk',
      importedFrom: 'importeret fra {fabric}',
      importedBy: 'Importeret af: {list}',
      importedCount: '+{n} importerede',
      owner: 'Ejer',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Fjern import',
      unimportConfirm: 'Fjern importen af netværket {name} (ejer {fabric}) fra denne fabric? Det afvises, så længe en port eller et LAGG i denne fabric mapper det, eller en gæst, App eller tjeneste kun betjenes gennem dette ben.',
      unimportRefused: 'Importen er stadig i brug — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Denne node tager allerede det netværk fra en anden fabric, den er medlem af: en node tager et delt netværk fra ÉT af sine ben (to uplinks på samme L2 i en bridge uden STP er et loop). Fjern mappingen på portene eller LAGG i en af de to fabrics.',
          otherFabricDerived: 'Dokumentet bærer blokken fra en fabric, som noden ikke længere erklærer et kabel mod: anvend først den fabrics plan (den foreslår fjernelse af dens enheder), eller overtag dem med take-ownership, hvis fabricen er væk.'
        },
        hint: 'O.3-derivationsplanen: for hver kablet node status, diff\'en afledt-vs-nuværende, den DEKLAREREDE bond-topologi, dual-stack-flips og de strukturerede afvisninger/advarsler. Skrivebeskyttet indtil den EKSPLICITTE apply — intet lander nogensinde af sig selv på en node.',
        refresh: 'Genindlæs planen',
        empty: 'Ingen node er kablet til denne fabric (og ingen bærer stadig dens blok).',
        refusal: 'Afvisning',
        warning: 'Advarsel',
        generation: 'dokumentgeneration {n}',
        state: {
          manual: 'Manuel',
          derived: 'Afledt',
          diverged: 'Afveget'
        },
        topologyTitle: 'Deklareret topologi',
        members: 'medlemmer',
        primary: 'primær',
        held: 'holdt på ÉT medlem',
        form: {
          perNetworkBond: 'Bond pr. netværk',
          singleBond: 'Enkelt fallback-bond',
          laggBond: 'LACP-bond (LAGG)',
          singlePort: 'Enkelt port'
        },
        colAction: 'Handling',
        colKind: 'Art',
        colDevice: 'Device',
        colDetail: 'Detalje',
        action: {
          add: 'tilføj',
          remove: 'fjern',
          replace: 'erstat'
        },
        diffEmpty: 'Ingen udestående diff — det anvendte dokument matcher renderet.',
        diffBlocked: 'Ingen diff: afvisningerne ovenfor blokerer denne node.',
        phasePlanned: 'planlagt (trin 1 af 3)',
        phaseDraining: 'ved at dræne (trin 2 af 3)',
        probeUnobserved: 'Drain-sonde: aldrig rapporteret — tomheden er UKENDT (en retire ville blive afvist nu).',
        probeFailed: 'Drain-sonde: observationen FEJLEDE — de kendte tidsstempler føres videre, aldrig et «tomt» ingen har målt.',
        probeActive: {
          one: 'Drain-sonde: {n} etableret forbindelse stadig på den gamle adresse',
          other: 'Drain-sonde: {n} etablerede forbindelser stadig på den gamle adresse'
        },
        probeLastActive: 'sidste aktivitet {time}',
        probeEmpty: {
          one: 'Drain-sonde: tom i {n} minut',
          other: 'Drain-sonde: tom i {n} minutter'
        },
        probeEmptyUnknown: 'Drain-sonde: tom (siden hvornår er ukendt).',
        impact: '{nics} vNIC og {apps} App på denne node bruger disse netværk: {list}',
        apply: 'Anvend på denne node',
        applyTitle: 'Anvend derivationen — {node}',
        applyIntro: 'Den afledte konfiguration omskriver netværksdokumentet for {node} ({n} ændringer) gennem samme dør som host-network-editoren — NetworkManager-checkpoint og ærlig probe inklusive. Planens advarsler nedenfor rejser med: læs dem før du bekræfter.',
        applyError: 'Apply fejlede',
        applyRefused: 'Noden afviste:',
        planMoved: 'Fabric\'en ændrede sig efter denne forhåndsvisning — INTET blev anvendt. Planen er genindlæst: se igen og prøv igen.',
        retire: 'Udfas',
        retireTitle: 'Point of no return — udfasning af {address}',
        restore: 'Gendan',
        restoreTip: 'Tilbage til snapshottet før apply (generation {previous}) — fortryd i ét trin (H13)',
        restoreTitle: 'Gendan det forrige dokument — {node}',
        restoreIntro: 'Netværksdokumentet for {node} går tilbage til snapshottet taget før seneste apply (generation {previous}), omskrevet som generation {next} i stedet for {current}. Workeren konvergerer det som ethvert andet dokument.',
        restoreRedo: 'Det erstattede dokument bliver det nye snapshot: at gendanne igen er redo.',
        restoreClosesChain: 'Snapshottet er det manuelle dokument fra før afledningen: kæden lukkes her — ingen yderligere fortryd, noden er manuel indtil næste apply.',
        restoreConfirm: 'Gendan',
        restoreError: 'Gendannelse mislykkedes',
        retireIntro: 'Dette fjerner {address} ({network}) fra {point} for altid. Efter denne handling er vejen tilbage det OMVENDTE flip — at gendeklarere den gamle adresse gennem samme engine — aldrig en blind gendannelse.',
        retireOld: 'Gammel adresse (fjernet)',
        retireNew: 'Ny adresse (bliver)',
        retireEmptyFact: 'Drain-sonden melder adressen tom: denne fjernelse afbryder ingen observeret forbindelse.',
        retireConfirm: 'Udfas adressen',
        severActiveLoss: {
          one: 'Afbryd {n} etableret forbindelse stadig på den gamle adresse — den dør med denne handling',
          other: 'Afbryd {n} etablerede forbindelser stadig på den gamle adresse — de dør med denne handling'
        },
        severUnknownLoss: 'Acceptér det UKENDTE: sonden har aldrig observeret denne adresse (eller observationen fejler) — levende forbindelser kan blive afbrudt.'
      },
      title: 'Fabric',
      createTitle: 'Opret fabric',
      networks: 'Netværk',
      switches: 'Switche',
      ports: 'Porte',
      laggs: 'LAGG',
      subnets: 'Subnets',
      tabOverview: 'Oversigt',
      tabNetworks: 'Logiske netværk',
      tabSwitches: 'Switche',
      overviewHint: 'Fabricen med ét blik: hvert logisk netværk med MTU og subnet (VLAN bor kun i mapningerne pr. port/pr. LAGG — det samme netværk kan rejse med forskellige tags på forskellige porte). Fabricen er registret over en EKSTERN infrastruktur — TVirt observerer og erklærer, laver aldrig provisioning og rører kun de NIC, der er registreret under dens kontrol.',
      absorptionHint: 'Hvert subnet erklæret her AFLEDER sin post i IPAM-registret i samme skrivning — det lever og dør med netværket.',
      scopeFixedHint: 'Scope er fast: klyngens rod — fysisk infrastruktur er pr. definition fælles for hele klyngen.',
      networksHint: 'Hvert netværk bærer en obligatorisk MTU (default 1500) og et obligatorisk subnet; gateway, DNS-servere og statiske ruter erklæret her er den ENESTE KILDE for servernes NIC, Apps og netværkstjenester.',
      switchesHint: 'Det manuelle register: en port er ubrugt, mappet (untagged trafik og pr. VLAN-tag på de logiske netværk) eller medlem af en LAGG — et medlem bærer ingen egne mapninger.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obligatorisk — IPAM afleder automatisk dets registerpost',
      nodeAddressing: 'Nodeadressering',
      nodeAddressingNone: 'Ingen — ingen adresse pr. node',
      nodeAddressingPool: 'Pool — én fast adresse pr. leveret node',
      nodeAddressingHint: 'Med Pool tildeler fabric-afledningen hver leveret node en adresse fra de områder, der er reserveret til TVirt (fast når først tildelt).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Reserverede ranges',
      dns: 'DNS-servere (kommaseparerede)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS og ruter erklæret her er den eneste kilde — servernes NIC, Apps og netværkstjenester trækker herfra',
      routesTitle: 'Statiske ruter',
      routeDestination: 'Destination (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Brugt',
      vlanMappings: 'VLAN-mapninger',
      vlanTag: 'VLAN-tag',
      vlanNetwork: 'Logisk netværk',
      nameTaken: 'Navnet er allerede brugt i fabricen',
      addNetwork: 'Tilføj netværk',
      editNetwork: 'Rediger netværk',
      deleteNetwork: 'Fjern netværk',
      deleteNetworkConfirm: 'Fjerne det logiske netværk {name} fra fabricen? Dets afledte subnet i IPAM dør med det (afvises, så længe en tjeneste eller en App bruger det). Port- og LAGG-mapninger der peger på det, ryddes.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Fysisk position (valgfri) — samme ordforråd som serverplaceringen; kun deklarativ',
      addSwitch: 'Tilføj switch',
      editSwitch: 'Rediger switch',
      deleteSwitch: 'Fjern switch',
      deleteSwitchConfirm: 'Fjerne switchen {name} med alle dens porte? LAGG-erne indsnævres tilsvarende (og dør under to porte).',
      addPort: 'Tilføj port',
      editPort: 'Rediger port',
      deletePort: 'Fjern port',
      deletePortConfirm: 'Fjerne porten {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:netværk)',
      taggedShort: 'Tagged',
      portCabling: 'Kabling',
      portState: 'Status',
      stateUnused: 'ubrugt',
      stateMapped: 'mappet',
      laggPortGuard: 'En port, der er medlem af en LAGG, redigeres fra LAGG-siden',
      laggsTitle: 'LAGG',
      laggsHint: 'En LAGG er 2+ porte i LACP og kan krydse switche (MLAG, transparent); kun ubrugte porte kan træde ind, LAGG-en er mapningsfladen, en fjernet port bliver ubrugt igen.',
      addLagg: 'Tilføj LAGG',
      editLagg: 'Rediger LAGG',
      deleteLagg: 'Fjern LAGG',
      deleteLaggConfirm: 'Fjerne LAGG-en {name}? Dens medlemsporte bliver ubrugte igen.',
      lacpRate: 'LACP-rate',
      laggPorts: 'Medlemsporte (2+)',
      laggPortsHint: 'Kun ubrugte porte kan træde ind — frigør først en mappet port',
      noNetworks: 'Ingen logiske netværk erklæret.',
      noSwitches: 'Ingen switch erklæret.',
      noLaggs: 'Ingen LAGG erklæret.',
      staleConflict: 'En anden operatør har ændret denne fabric, mens du redigerede den: lagringen blev afvist, så hans arbejde ikke bliver slettet. Dine ændringer er her stadig, urørte. Den opdaterede fabric er allerede genindlæst: bekræft igen for at anvende dem ovenpå, eller annullér og se hvad der er ændret.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Kun afledt: hvert subnet fødes af et logisk fabric-netværk eller et overlay — det redigeres ved kilden. De tildelte adresser viser, HVEM der holder dem; de TVirt-reserverede ranges er den automatiske tildelings pools.',
      search: 'Søg efter navn, CIDR eller adresse',
      empty: 'Ingen netværk — erklær et logisk fabric-netværk eller et overlay-subnet: IPAM afledes automatisk af dem.',
      reserved: 'Ranges reserveret til TVirt',
      address: 'Adresse',
      origin: 'Oprindelse',
      origin_declared: 'erklæret',
      origin_observed: 'observeret',
      holder: 'Holdt af',
      noAddresses: 'Ingen kendte adresser i dette subnet.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Rediger ved kilden'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Firewall-grupper',
      createTitle: 'Ny firewall-gruppe',
      editTitle: 'Rediger firewall-gruppe',
      empty: "Ingen firewall-grupper endnu — opret en: et genbrugeligt ordforråd af regler, refereret fra guest-NIC'erne ved navn.",
      nameHint: 'Bogstaver, cifre og indre . - _; unikt inden for sit scope (navnebrødre andetsteds skelnes med /scope/navn)',
      description: 'Beskrivelse',
      descriptionHint: 'Én linje om hensigten, vist overalt hvor gruppen vælges',
      enforced: 'Håndhævet på scopet',
      enforcedHint: 'Slukket: rent ordforråd — reglerne binder kun de NIC, der refererer gruppen. Tændt: reglerne binder hver guest-NIC med tændt firewall under gruppens scope, refereret eller ej.',
      enforcedChip: 'Håndhævet',
      enforcedChipHint: 'Reglerne binder hver guest-NIC med tændt firewall under gruppens scope, refereret eller ej',
      enforceWarning: 'Slås håndhævelsen til, binder reglerne HVER guest-NIC med tændt firewall under {scope} ved næste konvergens, også uden eksplicit reference — og inde i en aktiv chain er en forfaders drop endeligt: niveauerne nedenunder kan ikke genåbne det.',
      unenforceInfo: 'Fjernes håndhævelsen, bliver reglerne kun på de NIC, der refererer gruppen eksplicit.',
      rules: 'Regler',
      tabOverview: 'Oversigt',
      tabRules: 'Regler',
      orderHint: 'Rækkernes rækkefølge ER evalueringsrækkefølgen inden for gruppen: den første regel, der matcher, vinder.',
      statefulHint: 'Stateful er implicit: svarene på tilladt trafik passerer af sig selv (established/related accepteres, invalid smides væk — injiceret af motoren, aldrig skrevet i hånden).',
      noRules: 'Ingen regler — et ordforråd under opbygning: at referere det er lovligt og renderer ingenting.',
      addRule: 'Tilføj regel',
      direction: 'Retning',
      directionIn: 'Indgående',
      directionOut: 'Udgående',
      action: 'Handling',
      action_accept: 'Accepter',
      action_drop: 'Drop',
      action_reject: 'Afvis',
      protocol: 'Protokol',
      protocolAny: 'Enhver',
      ports: 'Porte',
      source: 'Kilde',
      dest: 'Destination',
      comment: 'Kommentar',
      addressHint: 'IPv4-CIDR eller <fabric>/<logisk netværk>; tom = enhver',
      moveUp: 'Flyt op',
      moveDown: 'Flyt ned',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Firewall-grupper',
      nicGroupsPlaceholder: 'Vælg en gruppe…',
      nicGroupsHint: 'De synlige grupper, inklusive dem fra de overordnede scopes (kan bruges nedad, ligesom tags)',
      nicGroupCount: { one: '{n} firewall-gruppe', other: '{n} firewall-grupper' },
      nicOff: 'Firewall slukket',
      pendingRestartHint: "Firewall-ændringer følger den gemte/anvendte model: de venter på næste power cycle (PendingRestart). Grupper håndhævet af overordnede scopes gælder, når NIC'ens firewall er tændt.",
      appConvergeHint: 'Firewall-ændringer træder i kraft ved containerens næste konvergens. Grupper håndhævet af overordnede scopes gælder, når firewallen er tændt.',
      enforcedAncestors: 'Håndhævet af overordnede scopes',
      enforcedAncestorsHint: "Denne gruppe gælder for hver NIC under sit scope, hvis firewall er TÆNDT — kontakten er NIC'ens hovedafbryder (slukket = slet ingen chain, forfædre inklusive); inde i en aktiv chain er forfaderens autoritet endelig: dens drop genåbnes ikke nedenunder."
    }
  }
}
